import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[(!_vm.hide)?_c('Toolbar'):_vm._e(),(!_vm.hide)?_c('Drawer',{attrs:{"items":[]},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}}):_vm._e(),_c(VMain,{staticClass:"main"},[_c('router-view')],1),(_vm.companyVisible)?_c('Company',{attrs:{"visible":_vm.companyVisible},on:{"setDialogVisible":_vm.actionCompany}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }